import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../Footer';
import { ContainerWrapper } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';
import useResize from '@/hooks/useResize';
import { getBlogDetail } from '@/api/frontData.api';
import { Flex, LoadingPage } from '@/layout';
import { errorHandler } from '@/utils/toastHandler';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { sify } from 'chinese-conv/dist';
import { Button } from '@/components/UI/Button';
import PATH from '@/router/path';

const BlogDetail = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const lang = useCurrentLang();
  const { isTablet, isMobile } = useResize();
  const [isLoading, setIsLoading] = useState(false);
  const { cus_title } = useParams();
  const navigate = useNavigate();

  const [blogDetail, setBlogDetail] = useState<Blog>();

  const initData = async () => {
    if (!cus_title) return;
    setIsLoading(true);
    try {
      const res = (await getBlogDetail(cus_title)).data;
      setBlogDetail(res);
    } catch (error) {
      console.log(error);
      navigate(PATH.langPage404.replace(':lang', lang), { replace: true });
      // errorHandler(t('error.server'));
    } finally {
      setIsLoading(false);
      // 將畫面滾動至最上方
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    initData();
  }, [lang, cus_title]);

  return (
    <>
      <ContainerWrapper isTablet={isTablet} isMobile={isMobile}>
        {isLoading ? (
          <LoadingPage isLoading={isLoading} />
        ) : blogDetail ? (
          <>
            <div className="title">
              <h1>
                {lang === 'en'
                  ? blogDetail.title_en
                  : lang === 'tc'
                    ? blogDetail.title
                    : sify(blogDetail.title)}
              </h1>
            </div>
            <div className="info">
              <div className="pic">
                <img src={blogDetail.img_url} alt="" />
              </div>
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: lang === 'en' ? blogDetail.info_en : lang === 'tc' ? blogDetail.info : sify(blogDetail.info),
                }}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </ContainerWrapper>
      <Footer />
    </>
  );
};

export default BlogDetail;
